import { useCallback, useEffect, useMemo, useState } from "react";
import "./tenantonboard.css";
import { DocumentService, LeaseApplicationRentIncomeVM, LeaseApplicationService, LeaseApplicationTenantSignatureVM, RentPayTypesEnum, TemplateService } from "@propertelligent/client-api";
import apiHelper from "../../../utils/apiHelper";
import { OnboardingRentIncomeCheckForm, } from "../../../typings/onboarding";
import SignatureCard from "./SignatureCard";
import { RentPayInfo } from "../component/RentPayInfo";
import { convertStreamAndDownloadBymimeTypes, staticTemplates } from "../../../utils/helper";
import { useError } from "../../../utils/context/ErrorContext";
import ApplicationCard from "../component/ApplicationCard";
import QuestionnairesInfo from "../component/Questionnaires";
import CreditCheckInfo from "../component/CreditCheckInfo";
import ReferencesInfo from "../component/ReferenceInfo";
import EmploymentHistoryInfo from "../component/EmploymentHistoryInfo";
import CurrentAddressInfo from "../component/CurrentAddressInfo";
import {  PubSub, TopicsEnum } from "../../../utils/pubsub";
import { ConfirmationPopup } from "../../../newComponents/confirmation-popup/confirmation-popup-demo";


const BoardingReview = ({ handleSubmit = undefined, editable, isEditClick, postData, leaseApplicationId = null, formData, setFormData,
  steps, landlord = false,  tenantEdit = null, getTenantsData = undefined, isPreview = false, id = undefined }): any => {
  const { errors, setErrors, errorMessages, setErrorMessages } = useError()
  const [templateData, setTemplateData] = useState<any>()
  const [leaseApplicationData, setleaseApplicationData] = useState<any>({
    BasicDetails: {}, 
    CreditCheck: {} as any, 
    CurrentAddress: {} as any,
     EmploymentHistory: [], 
     References: [], 
     RentIncomeCheck: {} as OnboardingRentIncomeCheckForm,
    Signature: { fullName: "", signedDateTime: "", } as LeaseApplicationTenantSignatureVM, Questionnaires: []
  })
  const [tenantId, setTenantId] = useState<Number>()
  
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [leaseApplicationStatus, setLeaseApplicationStatus] = useState()
  const [sectionToggles, setSectionToggles] = useState({});

  const fetchTemplateData = useCallback((templateId) => {
    if (templateId) {
      apiHelper(TemplateService.getApiTemplate, { showNotification: false }, templateId)
        .then((template) => { setTemplateData(template?.data?.success) })
    }
  }, [])

  const fetchLeaseData = () => {
    if (leaseApplicationId) {
      apiHelper(LeaseApplicationService.getApiLeaseApplication1, { showNotification: false }, leaseApplicationId)
        .then((response: any) => {
          if (response?.data?.success) {
            let leaseData = response?.data?.success;
            setTenantId(leaseData?.tenantId)
            let leaseDataSections = response?.data?.success?.dataSections
            setLeaseApplicationStatus(response?.data?.success?.leaseApplicationStatusTypeId)
            fetchTemplateData(response?.data?.success?.templateId)
            setleaseApplicationData(prevFormData => ({
              ...prevFormData,
              BasicDetails: leaseData?.tenant ? { firstName: leaseData?.tenant?.firstName, lastName: leaseData?.tenant?.lastName, email: leaseData?.tenant?.email, phoneNumber: leaseData?.tenant?.phoneNumber } : null,
              CreditCheck: leaseDataSections?.CreditCheck ? JSON.parse(leaseDataSections.CreditCheck) : null,
              CurrentAddress: leaseDataSections?.CurrentAddress ? JSON.parse(leaseDataSections.CurrentAddress) : null,
              EmploymentHistory: leaseDataSections?.EmploymentHistory ? JSON.parse(leaseDataSections.EmploymentHistory) : null,
              References: leaseDataSections?.References ? JSON.parse(leaseDataSections.References) : null,
              RentIncomeCheck: leaseDataSections?.RentIncomeCheck ? JSON.parse(leaseDataSections.RentIncomeCheck) : null,
              Questionnaires: leaseDataSections?.Questionnaires ? JSON.parse(leaseDataSections.Questionnaires) : null,
              Signature: leaseDataSections?.Signature ? JSON.parse(leaseDataSections.Signature) : null,
            }));
            setSectionToggles(prevToggles => ({
              ...prevToggles,
              ...Object.keys(leaseData?.reviewSections || {}).reduce((acc, key) => {
                acc[key] = leaseData.reviewSections[key] || { approved: false, notes: "" };
                return acc;
              }, {} as typeof prevToggles) // Ensuring TypeScript knows the correct type
            }));
          }
        }).catch((error) => { })
    }
  }

  // useMemo(() => { if (getTenantsData) { getTenantsData() ;fetchLeaseData() } }, [sectionToggles ,setSectionToggles])
useEffect(() => {
    if (leaseApplicationId) {
        fetchLeaseData();
        if (getTenantsData) getTenantsData();
    }
}, [leaseApplicationId]);
  useEffect(() => {
    const buildSectionArray = (range = 0, template) => Array.from({ length: range }, () => ({ ...template }));
    fetchLeaseData();
    if (postData) {
      if (isPreview) {
        setTemplateData(postData);
      }
      const { leaseApplicationTemplateSections = {} } = postData;
      const {
        EmploymentHistory = { requiredRange: 0 },
        References = { requiredRange: 0 },
        Questionnaires = { questions: [] },
      } = leaseApplicationTemplateSections;
      setleaseApplicationData({
        BasicDetails: { ...staticTemplates.basicDetails },
        CreditCheck: { ...staticTemplates.creditCheck },
        CurrentAddress: { ...staticTemplates.currentAddress },
        EmploymentHistory: buildSectionArray(EmploymentHistory.requiredRange, staticTemplates.employment),
        References: buildSectionArray(References.requiredRange, staticTemplates.reference),
        RentIncomeCheck: {
          rentPayTypeId: RentPayTypesEnum.Both,
          employerDetails: { ...staticTemplates.contact },
          assistedDetails: { ...staticTemplates.contact },
          employmentIncome: 400,
          assistedAmount: 300,
        } as LeaseApplicationRentIncomeVM,
        Questionnaires: Questionnaires.questions,
        Signature: {
          fullName: "Murtaza Abdeali",
          signedDateTime: "Jun 29, 2023",
        },
      });
    }
  }, [postData, leaseApplicationId, tenantEdit, setSectionToggles, isPreview]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((preValue) => ({
      ...preValue,
      Signature: {
        ...preValue.Signature,
        [name]: value
      },
    }));
    const errorKey = `${name}`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
  };

  const handleEditClick = (stepName) => {
    const stepIndex = steps.indexOf(stepName);
    if (stepIndex !== -1) {
      isEditClick(stepIndex);
    } else { console.error("Step not found:") }
  };

  const sharedProps = {
    leaseApplicationId,
    fetchLeaseData,
    editable,
    landlord,
    sectionToggles,
    setSectionToggles,
    leaseApplicationStatus,

  };

  const signatureFormData = (editable || isPreview)
    ? (formData ?? leaseApplicationData?.Signature)
    : leaseApplicationData?.Signature;

  const isSignatureCompleted = (sig) => {
    const name = (sig?.fullName ?? "").trim();
    const isPlaceholder = !name || name === "Landlord" || name === "Tenant";
    return !isPlaceholder && !!sig?.signedDateTime;
  };

  // Live tenant signing (editable) and landlord review always show the Signature
  // section so template clause text is visible before the tenant signs.
  // Print/export (editable=false, landlord=false, incomplete) still hides it (#19/#20).
  const shouldShowSignature =
    editable === true ||
    landlord === true ||
    isSignatureCompleted(signatureFormData);

  const renderConditionalSection = (headerName, sectionName, renderFunction) => {
    const leaseDataExists = leaseApplicationData?.[sectionName];
    const templateOrPostExists =
      postData?.leaseApplicationTemplateSections?.[sectionName] ||
      templateData?.leaseApplicationTemplateSections?.[sectionName];
       if (!leaseDataExists || !templateOrPostExists) return null;
    return (
      (templateOrPostExists || leaseDataExists ) && (
        <ApplicationCard
          cardHeaderName={headerName}
          sectionName={sectionName}
          component={renderFunction()}
          handleEditClick={() => handleEditClick(sectionName)}
          {...sharedProps}
        />
      )
    );
  };
  const downloadDocument = (id, fileName) => {
    // setIsUploading(true);
    apiHelper(
      DocumentService.getApiDocumentBase641,
      { showNotification: false },
      id
    ).then((docRes) => {
      convertStreamAndDownloadBymimeTypes(docRes?.data?.success, fileName);
    }).catch((docErr) => {
    });
  };

  const handleSignApplication = () => {
    handleSubmit()
    setShowConfirmation(false)
  }

  useEffect(() => {
  const unsubscribe = PubSub.subscribe(
    TopicsEnum.RefreshLeaseData.toString(),
    () => {
      fetchLeaseData();
    }
  );
  return () => unsubscribe();
}, []);
  
  return (
    <>
      <section className="application-review-body w-100 flexColumn gap-3">
        <>{renderConditionalSection("Current Address", "CurrentAddress",
          () => <CurrentAddressInfo
            CurrentAddress={leaseApplicationData?.CurrentAddress} />)
        }
          {renderConditionalSection("Credit Check", "CreditCheck",
            () => <CreditCheckInfo
              CreditCheck={leaseApplicationData?.CreditCheck} />)
          }
          {renderConditionalSection("Rent Pay Information", "RentIncomeCheck",
            () => leaseApplicationData?.RentIncomeCheck !== null && <RentPayInfo id={id} tenantId={tenantId}
              downloadDocument={downloadDocument} leaseApplication={leaseApplicationId} data={leaseApplicationData?.RentIncomeCheck} />)
          }
          {renderConditionalSection("Employment History", "EmploymentHistory",
            () => <EmploymentHistoryInfo
              EmploymentHistory={leaseApplicationData?.EmploymentHistory} />)

}
          {renderConditionalSection("References", "References",
            () => <ReferencesInfo
              References={leaseApplicationData?.References} />)
          }
          {renderConditionalSection("Questionnaire", "Questionnaires",
            () => <QuestionnairesInfo
              leaseApplicationData={leaseApplicationData?.Questionnaires}
              templateData={templateData?.leaseApplicationTemplateSections?.Questionnaires?.questions}
              leaseApplication={leaseApplicationId} />)
          }
          {shouldShowSignature && (
            <div id="signature-section" className="w-100">
              <ApplicationCard
                cardHeaderName="Signature"
                sectionName="Signature"
                component={
                  <div className="">
                   {/* <p className="normal_text ">I confirm that the information provided above is true and based on my personal knowledge. I give my consent to share or use this information as needed.</p> */}
                  <SignatureCard
                    clause={templateData?.leaseApplicationTemplateSections?.Signature?.clause}
                    formData={signatureFormData}
                    setFormData={setFormData}
                    editable={editable}
                    handleChange={handleChange}
                    isPreview={isPreview}
                    handleClick={() => setShowConfirmation(true)}
                   displayText={templateData?.leaseApplicationTemplateSections?.Signature?.clause}
                  />
                  </div>
                }
                handleEditClick={() => handleEditClick("Signature")}
                {...sharedProps}
              />
            </div>
          )}

          {showConfirmation && (
                                  <ConfirmationPopup
                        isOpen={true}
                        title="Confirm Signature"
                        message="Are you sure you want to Sign Application?"
                        primaryButtonLabel="No"
                        secondaryButtonLabel="Yes"
                        onPrimaryAction={() => setShowConfirmation(false)}
                        onSecondaryAction={handleSignApplication}
                        onClose={() => setShowConfirmation(false)}
                        isPrimaryAction={false}
                        isPrimaryDestructive={false}
                      />
           
          )}
        </>
        {/* )} */}
      </section>
    </>);
};
export default BoardingReview;
